const functionalColor = {
  success1: '#00B42AFF',
  success2: '#00B42A99',
  success3: '#009022FF',
  success4: '#00B42A1A',

  warning1: '#FF7D00FF',
  warning2: '#FF7D0099',
  warning3: '#CC6400FF',
  warning4: '#FF7D001A',

  danger1: '#F53F3FFF',
  danger2: '#F53F3F99',
  danger3: '#DC3939FF',
  danger4: '#F53F3F1A'
}

const others = {
  'color-text1': '#000000',
  'color-text2': '#333333',
  'color-text3': '#666666',
  'color-text4': '#999999',
  'color-text5': '#cccccc',
  'color-text6': '#ffffff',

  'color-bg': '#F1F3F5',
  'color-border1': '#E5E6EB',
  'color-border2': '#DCDCDC',

  'font-size-title1': '24px',
  'font-size-title2': '20px',
  'font-size-title3': '16px',
  'font-size-body': '14px',
  'font-size-caption': '12px',

  'line-height-title1': '32px',
  'line-height-title2': '28px',
  'line-height-title3': '24px',
  'line-height-body': '22px',
  'line-height-caption': '20px',

  'space-mini': '4px',
  'space-small': '8px',
  'space-medium': '16px',
  'space-large': '24px',

  shadow1: '0px 4px 6px rgba(0, 0, 0, 0.08)',
  shadow2: '0px 6px 10px rgba(0, 0, 0, 0.16)',
  shadow3: '0px 8px 14px rgba(0, 0, 0, 0.24)',
  'shadow-special': '0px -2px 6px rgba(0, 0, 0, 0.06)'
}

type BrandColorKey = 'primaryColor'

type CssVarsKey = keyof typeof others

export const cssVars: Record<CssVarsKey, string> & { [key in BrandColorKey]?: string } = {
  get warningColor() {
    return functionalColor.warning1
  },
  get successColor() {
    return functionalColor.success1
  },
  get dangerColor() {
    return functionalColor.danger1
  },
  ...others
}

export type CssVars = typeof cssVars

const themes = import.meta.glob<any>('@/themes/theme-*/index.ts', { eager: true })
export const themeMap = Object.keys(themes).reduce(
  (acc, key) => {
    const themeName = key.replace(/^.*\/themes\//, '').replace(/\/index.ts$/, '')
    acc[themeName] = themes[key]
    return acc
  },
  {} as Record<string, any>
)

export function changeTheme(theme: string) {
  if (themeMap[theme]) {
    Object.assign(cssVars, { primaryColor: themeMap[theme].brandColor?.brand1 })
  }
  return cssVars
}

export async function getNaiveThemeOverrides(theme: keyof typeof themeMap) {
  const modules = import.meta.glob('./theme-*/theme-naive.json')
  const naiveTheme: any = await modules[`./${theme}/theme-naive.json`]()
  if (naiveTheme.default) {
    return naiveTheme.default
  }
  return {}
}
import theme1Css from './theme-1/theme-naive.css?raw'
export async function getNaiveThemeCustomStyle(theme: keyof typeof themeMap) {
  if (theme === 'theme-1') {
    return theme1Css
  }
  return ''
}
